
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import swal from 'sweetalert2';
import { DriverService } from 'src/app/services/driver.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { GenericValidator } from 'src/app/views/layout/validators/generic-validator';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { result } from 'lodash';

import { ApproveStatusType } from 'src/enum/approvestatustype';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ManufacturerUpdatePopupComponent } from '../manufacturer/manufacturerupdatepopup/manufacturerupdatepopup.component';
import { ManufacturerpopupComponent } from '../manufacturer/manufacturerpopup/manufacturerpopup.component';
import { ManufacturerclarifypopupComponent } from '../manufacturer/manufacturerclarifypopup/manufacturerclarifypopup.component';
import { ManufacturerPopupComponent } from './manufacturepopup.component';
import { TranslateService } from '@ngx-translate/core';
import { RegionService } from 'src/app/services/region.service';
import { SecurityService } from 'src/app/services/security.service';
interface FoodNode {
  name: string;
  color?: string;
  children?: FoodNode[];
  key?: number;
  dbtpdmApproveStatusType?: number;
  dbtProductDistrictMappingId?: number;
  id?: number;
}

@Component({
  selector: "app-manufacturer-detail",
  templateUrl: "./manufacturer-detail.component.html",
  styleUrls: ["./manufacturer-detail.component.scss"],
})
export class ManufacturerDetailComponent implements OnInit {
  selectedIndex: number;
  balanceSheetFileName: any;
  balanceSheetFileName1: any;
  balanceSheetfiles1: any;
  attachmentbalanceSheetData: any[] = [];
  attachmentbalanceSheetData1: any[] = [];
  balanceSheetfiles2: any;
  attachmentbalanceSheetData2: any[] = [];
  form: FormGroup;
  balancesheetform: FormGroup;
  form1: FormGroup;
  form2:FormGroup;
  formEditMode: boolean;
  manufacturerListCopy: any[];
  manufacturerList: any[];
  subDistrictList: any[] = [];
  subDistrictListCopy: any[] = [];
  villageList: any[];
  villageListCopy: any[] = [];
  stateList: any[];
  stateListCopy: any[];
  districtList: any[];
  districtListCopy: any[];
  showtextdistrict = false;
  manufacturer: boolean = false;
  manufactureranddealer: boolean = false;
  organisationTypeList: any[];
  organisationTypeListCopy: any[];
  dropdownSettings: any = {};
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  register: boolean;
  formp3: FormGroup;
  manufacturerDetail: any;
  registrationType: any;
  manufacturerType: any = [];
  disabled: boolean = false;
  disabledaddress: boolean = false;
  companyListCopy: any;
  companyList: any;
  today: Date;
  max: Date;
  minDate: Date;
  manufactuerss: any;
  type: any;
  msme: any;
  routeParams: any;
  id: number;
  actioninfo: number;
  isdisable: boolean = false;
  isCorporateContact: boolean = true;
  isAuthorizedContact: boolean = true;
  isBalanceSheet: boolean = true;
  ismsme: boolean = true;
  balanceRequired: boolean = false;
  loginid: any;
  loadBalanceList: any[] = [];
  gstImagePath: string;
  panImagePath: string;
  msmeImagePath: string;
  show: boolean = false;
  gstStatus: boolean = false;
  verify: boolean = false;
  gstDetail: any;
  statusType: number;
  val: any;
  panno: any;
  disabledstateaddress: boolean;
  disableddistrictaddress: boolean;
  isGstVerified: boolean;
  isContinue: boolean;
  manufacturerId: any;
  view: boolean = false;
  loadbalance: boolean = false;
  manufactureredit: any[] = [];
  roleId: any;
  incorporationImagePath: any;
  tINImagePath: any;
  miscellaneousImagePath: any;
  cnImagePath: string;
  upload: boolean = false;
  balanceSheetFileName2: any;
  fileType: number;
  balanceSheetfiles: any;
  filesResult: any;
  balanceSheetData: any[] = [];
  msmeFileName: any;
  msmefiles: any;
  attachmentData: any[] = [];
  manufacturerTypeList: any[] = [];
  maindisabled: boolean = false;
  isSeekClarification: boolean = false;
  manufacturerTypeIdList: any[] = [];
  loginId: any;
  selectedTabIndex: number;
  treeControl = new NestedTreeControl<FoodNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  productTreeList: any[] = [];
  TREE_DATA: FoodNode[] = [];
  organisationName: any;
  IsAllDistrict: boolean = false;
  Approvedstatus: any;
  approvedStatusType: number;
  dbtProductDistrictMappingId: any;
  node3: FoodNode;
  statusapprej: boolean = false;
  approveresult: any;
  isShow: boolean = false;
  isDealerNetwork: boolean = false;
  isTimeline: boolean = false;
  isProduct: boolean = false;
  loading: boolean = false;
  loading1: boolean
  public roletype = RoleType;
  financialyearlist: any[];
  yearsListTabTwo: any[];
  filterfinancialyearlist: any[];
  currentYear: any;
  currentMonth:any
  curyear: any;
  prop:boolean

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private driverService: DriverService,
    public showDialog: MatDialog,
    private bookingService: BookingService,
    private usersession: UserSessionService,
    private manufacturerService: ManufacturerService,
    private navigationService: NavigationService,
    private cashBookingService: CashBookingService,
    private genericValidator: GenericValidator,
    private _location: Location,
    public addServiceDialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private regionService:RegionService,
    private securityService: SecurityService
  ) {
    this.stateList = [];
    this.stateListCopy = [];
    this.districtList = [];
    this.districtListCopy = [];
    this.organisationTypeList = [];
    this.organisationTypeListCopy = [];
    this.formEditMode = true;
    this.roleId = this.usersession.roleId();
    this.routeParams = route.snapshot.params;
    debugger
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.id = decId;
    this.loading1 = true
    this.actioninfo = this.routeParams.actionInfo;
    if (this.roleId == RoleType.DBTAdmin) {
      this.maindisabled = true;
    } else {
      this.maindisabled = false;
    }
    if (this.actioninfo == 1) {
      this.isdisable = true;
    }
    if (this.actioninfo == 2) {
      this.view = true;
      this.maindisabled = true;
    }
    if (this.actioninfo == 3) {
      this.show = true;
    }
    
  }

  ngOnInit(): void {
    const fragment = this.route.snapshot.fragment;
    if (fragment === "product") {
      this.selectedIndex = 1;
    }

    this.initializeValidators();
    this.getStates();
    this.getmanufacturerList(true);
    this.getManufacturerDetail();
    this.getcompanyRegisteredList(true);
    this.getfinancialyear(true);

    this.today = new Date();
    this.max = new Date(moment(new Date()).add(1, 'days').format('YYYY, MM, DD'));
    this.loading = false;
    this.disabled = true;
    this.disabledaddress = true;
    // this.manufacturer = true;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
    this.currentYear = this.today.getFullYear();
    this.currentMonth = this.today.getMonth(); 
  }

  handleProductTabClick(e: any) {
    const baseURL =
      this.route.snapshot.url[0].path +
      "/" +
      this.route.snapshot.url[1].path +
      "/" +
      this.route.snapshot.url[2].path;
    if (e.index == 1) {
      this.isProduct = true;
    } else if (e.index == 2) {
      this.isTimeline = true;
    } else if (e.index == 3) {
      if (this.productTreeList.length == 0) {
        this.loading = true;
        this.getmanufacturerTree();
      }
      this.isDealerNetwork = true;
    }

    if (e.index === 1 && this.route.snapshot.fragment !== "product") {
      this.route.snapshot.fragment = "product";
      this.location.go(baseURL + "#product");
    } else {
      this.route.snapshot.fragment = "";
      this.location.go(baseURL);
    }
  }

  balancesheetSave() {
    if (this.balancesheetform.valid) {
      // this.wizardForm.goToNextStep();
    } else {
      this.alertService.error('Please fill the Mandatory fields');
      this.genericValidator.validateFormControl(this.balancesheetform);
    }
  }
  changeOptions(event: any) {
    if (event.value == 1) {
      this.manufacturer = true;
      this.registrationType = event.value;
      this.register = this.manufacturer;
      this.manufactureranddealer = false;
    } else {
      this.manufacturer = false;
      this.manufactureranddealer = true;
      this.registrationType = event.value;
      this.register = this.manufactureranddealer;
    }
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      mobileNo: ['', Validators.required],
      organisationName: [''],
      organisationTName: [''],
      constitutionOfBusiness: ['', Validators.required],
      panNo: [''],
      gstNo: [''],
      tinNo: [''],
      faxNo: [''],
      gstStatus: [''],
      website: [''],
      // manufacturerType: [''],
      organisationAddress: [''],
      pinCode: [''],
      stateId: [''],
      talukId: [''],
      villageId: [''],
      incorporationTs: [''],
      districtId: [''],
      customerCareNo: [''],
      customerCareNo1: [''],
      customerCareNo2: [''],
      corporateContactPersonName: ['', Validators.required],
      corporateContactPersonDesignation: ['', Validators.required],
      corporateContactPersonMobileNo: ['', Validators.required],
      corporateContactPersonEmail: ['', Validators.required],
      authorizedPersonName: ['', Validators.required],
      authorizedPersonDesignation: ['', Validators.required],
      authorizedPersonMobileNo: ['', Validators.required],
      authorizedPersonEmail: ['', Validators.required],
      email: [''],
      companyRegisterType: ['', Validators.required],
      certificateNumber: [''],
      validityEndTs: [''],
      validityStartTs: [''],
      // manufacturerType: [null],
      msme_file: [''],
      msme_filename: ['', ''],
      // balanceSheet_file: [''],
      // balanceSheet_filename: ['', ''],
    });
    this.balancesheetform = this.formBuilder.group({
      year: [''],
      turnover: [''],
      turnover1: [''],
      turnover2: [''],
      balanceSheet_file: [''],
      balanceSheet_filename: ['', ''],
      balanceSheet_file1: [''],
      balanceSheet_filename1: ['', ''],
      balanceSheet_file2: [''],
      balanceSheet_filename2: ['', ''],


    });

    this.form1 = this.formBuilder.group({
      registrationType: [''],
      manufacturerType: [''],
    });



    this.form2=this.formBuilder.group({
      yearId:[]
    })

  }

  change(event: any) {
    this.TREE_DATA = [];
    this.dataSource.data = [];
    this.IsAllDistrict = event.checked;
    this.getmanufacturerTree();
  }

  getmanufacturerTree() {
    this.productTreeList = [];
    this.TREE_DATA=[];
    this.manufacturerService
      .getManufacturerTreeChartflow(this.id, this.IsAllDistrict,this.form2.value.yearId, true)
      .subscribe((result) => {
        if (result) {

          this.productTreeList = result;
          this.TREE_DATA.push(result);
          this.dataSource.data = this.TREE_DATA;
          if (this.isShow == true) {
            this.expand();
          }
          this.loading = false;
        }
      });
  }

  changeYear(event)
  {
    localStorage.setItem('year', this.form2.value.yearId);
    this.getmanufacturerTree();
  }


  getfinancialyear(refresh: boolean) {
    this.regionService.getFinYear(refresh).subscribe(result => {
      if (result) {
        this.financialyearlist = [];
        this.yearsListTabTwo = [];
        this.filterfinancialyearlist = [];
        this.financialyearlist = result;
        // this.filterfinancialyearlist.push({ key: 0, value: "All", startYear: 0, endYear: 0 });
        this.financialyearlist.forEach(element => {
          this.filterfinancialyearlist.push(element);
          this.yearsListTabTwo.push(element);
        });

        this.financialyearlist = this.financialyearlist;

        var financialYear = "";
        if (this.currentMonth >= 0 && this.currentMonth <= 2) {
          financialYear = "FY " + ((this.currentYear - 1).toString() + '-' + this.currentYear.toString().slice(-2));
        } else {
          financialYear = "FY " + ((this.currentYear).toString() + '-' + (this.currentYear + 1).toString().slice(-2));
        }
        this.curyear = this.financialyearlist.find(i => i.value == financialYear);
        this.form2.controls["yearId"].setValue(this.curyear.key);
        localStorage.setItem('year', this.form2.value.yearId);

        this.getmanufacturerTree();
        localStorage.setItem('year', this.form2.value.yearId);

        // this.form.controls["yearId"].setValue(this.currentYear[0].key);
      }
    });
  }

  getColor(node: FoodNode) {
    if (this.dataSource.data[0]?.children?.[0]?.children?.length === 0) {
      return 'white'
    } else if (!this.dataSource.data[0]?.children?.[0]?.children?.[0].children) {
      if (!node?.children) {
        return node.color
      } else {
        return 'white'
      }
    } else if (!node?.children?.[0]?.children || !node?.children) {
      return node.color;
    } else {
      return 'white'
    }
  }

  getCheck(node: FoodNode) {
    let disp: boolean = false
    if (!node?.children?.[0]?.children || !node?.children) {
      node?.children.forEach(element => {
        if (element.dbtpdmApproveStatusType == 0 || element.dbtpdmApproveStatusType == 2) {
          disp = true
        }
      });
      if (disp) {
        return true;

      }
    }
    else {
      return false
    }
  }

  // getCr(node: FoodNode) {
  //   return node.dbtpdmApproveStatusType = 1;
  // }
  onChange(node, event) {
    if (node && node.children) {
      node.children.forEach(v => {
        if (event.checked) {
          v.checked = true;
        } else {
          v.checked = false;
        }
      });
    }


  }

  onNodeChange(node,event)
  {
    if (node) {
        if (event.checked) {
          node.checked = true;
        } else {
          node.checked = false;
        }
    }
  }


  getBgColor(node: FoodNode) {
    if (this.dataSource.data[0]?.children?.[0]?.children?.length === 0) {
      return node.color
    } else if (!this.dataSource.data[0]?.children?.[0]?.children?.[0].children) {
      if (!node?.children) {
        return 'white'
      } else {
        return node.color
      }
    } else if (!node?.children?.[0]?.children || !node?.children) {
      return 'white'
    } else {
      return node.color;
    }
  }

  expand() {
    this.dataSource.data.forEach(node => {

      if (node.children) {
        this.treeControl.expand(node);
        node.children.forEach(node1 => {
          if (node1.children) {
            this.treeControl.expand(node1);
            node1.children.forEach(node2 => {
              if (node2.children) {
                this.treeControl.expand(node2);
                node2.children.forEach(node3 => {
                  if (node3.children)
                    this.treeControl.expand(node3);

                  this.node3 = node3
                });
              }
            });
          }
        });
      }
    });
  }

  collapse() {
    this.treeControl.collapseAll();
  }
  hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;

  isGstVerify() {
    if (this.form.controls['gstNo'].valid) {
      this.loading = true;
      this.bookingService.getGstCheck(this.form.value.gstNo, true).subscribe(res => {
        if (res) {
          this.gstDetail = res;
          this.statusType = 1;
          this.val = this.form.value.gstNo;
          this.panno = this.val.slice(2, -3);
          this.disabled = true;
          this.disabledaddress = true;
          this.disabledstateaddress = true;
          this.disableddistrictaddress = true;
          this.isGstVerified = true;
          let state = this.stateListCopy.filter(i => i.value.trim().toLowerCase() == res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.stateName.trim().toLowerCase());
          if (state != null && state.length > 0) {
            this.form.controls['stateId'].setValue(state[0].key);
            this.cashBookingService.districtByState(state[0].key, true).subscribe(result => {
              if (result) {
                this.districtList = result;
                this.districtListCopy = result;
                let district = result.filter(i => i.value.trim().toLowerCase() == res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.districtName.trim().toLowerCase());
                if (district != null && district.length > 0) {
                  this.form.controls['districtId'].setValue(district[0].key);
                  if (this.districtListCopy[0].key) {
                    this.cashBookingService.talukData(district[0].key, 1, true).subscribe(result => {
                      if (result) {
                        this.subDistrictList = result;
                        this.subDistrictListCopy = result;
                      }
                    });
                  }
                } else {
                  this.disabledaddress = false;
                  this.disableddistrictaddress = false;
                }
              }
            });

          } else {
            this.disabledaddress = false;
            this.disabledstateaddress = false;
            this.disableddistrictaddress = false;
          }
          let address = (res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.buildingNumber).concat(res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.location, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.streetName, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.districtName, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.stateName, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.pincode);
          this.form.controls['organisationName'].setValue(res.constitutionOfBusiness);
          this.form.controls['organisationTName'].setValue(res.organisationTName);
          this.form.controls['constitutionOfBusiness'].setValue(res.legalNameOfBusiness);
          this.form.controls['pinCode'].setValue(res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.pincode);
          this.form.controls['organisationAddress'].setValue(address);
          this.form.controls['gstStatus'].setValue(res.gstnStatus);
          this.form.controls['panNo'].setValue(this.panno);
          this.loading = false;
        } else {

          this.alertService.error('Invalid GST No');
          this.loading = false;

        }
      });
    }

  }

  getmanufacturerList(refresh: boolean) {
    this.manufacturerList = [];
    this.manufacturerListCopy = [];
    this.manufacturerService.getManufacturerList(refresh).subscribe(result => {
      if (result) {
        // this.loading1 = false
        this.manufacturerList = result;
        this.manufacturerListCopy = this.manufacturerList;
        this.manufacturerListCopy = this.manufacturerListCopy.slice();
      }
    });
  }

  ischangeEvent() {

    var date = moment(this.form.value.startDate).format('YYYY-MM-DD');
    this.minDate = new Date(date);
  }

  onmsmeFileSelected(event1: any) {
    const file = event1.target.files[0];
    if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.msmeFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/")
        if (getFileType[1] == 'pdf') {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.msmefiles = event.target.result;
            this.filesResult = event.target.result.split(',')[1];
            this.form.controls['msme_file'].setValue(this.filesResult);
            this.form.controls['msme_filename'].setValue(file.name);
            this.attachmentData.push({
              'id': ((this.attachmentData.length) + 1) - 1,
              'base64String': this.filesResult,
              'attachmentFilename': file.name,
              'fileType': this.fileType,
              'attachmentType': 16
            });
          }

        }
      } else {
        this.alertService.warning('File size is large, Please upload less than 2 MB');
      }
    } else {
      this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
    }

  }


  onCancel() {
    this.manufacturerTypeList = [];
    this.manufacturer = false;
    this.manufactureranddealer = false;
    this.getManufacturerDetail();
  }
  onBalanceSheetFileSelected(i, event1: any) {
    if (i == 0) {
      const file = event1.target.files[0];
      if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize <= 2048) {
          this.balanceSheetFileName = file.name;
          let checkType = file.type;
          let getFileType = checkType.split("/")
          if (getFileType[1] == 'pdf') {
            this.fileType = 2;
          } else {
            this.fileType = 1;
          }
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.balanceSheetfiles = event.target.result;
              this.filesResult = event.target.result.split(',')[1];
              this.balancesheetform.controls['balanceSheet_file'].setValue(this.filesResult);
              this.balancesheetform.controls['balanceSheet_filename'].setValue(file.name);
              this.attachmentbalanceSheetData.push({
                'id': ((this.attachmentbalanceSheetData.length) + 1) - 1,
                'base64String': this.filesResult,
                'attachmentFilename': file.name,
                'fileType': this.fileType,
                'attachmentType': 17
              });
            }
          }
        } else {
          this.alertService.warning('File size is large, Please upload less than 2 MB');
        }
      } else {
        this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
      }
    }
    else if (i == 1) {
      const file = event1.target.files[0];
      if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize <= 2048) {
          this.balanceSheetFileName1 = file.name;
          let checkType = file.type;
          let getFileType = checkType.split("/")
          if (getFileType[1] == 'pdf') {
            this.fileType = 2;
          } else {
            this.fileType = 1;
          }
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.balanceSheetfiles1 = event.target.result;
              this.filesResult = event.target.result.split(',')[1];
              this.balancesheetform.controls['balanceSheet_file1'].setValue(this.filesResult);
              this.balancesheetform.controls['balanceSheet_filename1'].setValue(file.name);
              this.attachmentbalanceSheetData1.push({
                'id': ((this.attachmentbalanceSheetData1.length) + 1) - 1,
                'base64String': this.filesResult,
                'attachmentFilename': file.name,
                'fileType': this.fileType,
                'attachmentType': 17
              });
            }
          }
        } else {
          this.alertService.warning('File size is large, Please upload less than 2 MB');
        }
      } else {
        this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
      }
    }
    else {
      const file = event1.target.files[0];
      if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize <= 2048) {
          this.balanceSheetFileName2 = file.name;
          let checkType = file.type;
          let getFileType = checkType.split("/")
          if (getFileType[1] == 'pdf') {
            this.fileType = 2;
          } else {
            this.fileType = 1;
          }
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.balanceSheetfiles2 = event.target.result;
              this.filesResult = event.target.result.split(',')[1];
              this.balancesheetform.controls['balanceSheet_file2'].setValue(this.filesResult);
              this.balancesheetform.controls['balanceSheet_filename2'].setValue(file.name);
              this.attachmentbalanceSheetData2.push({
                'id': ((this.attachmentbalanceSheetData2.length) + 1) - 1,
                'base64String': this.filesResult,
                'attachmentFilename': file.name,
                'fileType': this.fileType,
                'attachmentType': 17
              });
            }
          }
        } else {
          this.alertService.warning('File size is large, Please upload less than 2 MB');
        }
      } else {
        this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
      }
    }

  }

  getStates() {
    this.stateList = [];
    this.driverService.getStateLookUp(true).subscribe(res => {
      if (res) {
        this.stateList = res;
        this.stateListCopy = res;
      }
    });
  }

  getManufacturerDetail() {
    this.loading = true;
    this.manufacturerService.getManufacturer(this.id, true).subscribe(res => {
      if (res) {
        this.loading1 = false
        let manufacturerType = JSON.parse(res.manufacturerType);
        manufacturerType.forEach(element => {
          let item = this.manufacturerListCopy.filter(i => i.key == element);
          this.manufacturerTypeList.push(item[0]);
        });
        this.form1.controls["manufacturerType"].setValue(this.manufacturerTypeList);
        this.form1.controls['manufacturerType'].clearValidators();
        this.loadBalanceList = []
        this.manufacturerDetail = res;
        this.loginId = res.loginId;
        this.organisationName = res.organisationName
        this.isSeekClarification = res.isSeekClarification;
        if(/Pro|pro|PRO/.test(res.constitutionOfBusiness))
        {
          this.prop=true
        }
        if (res.manufacturerEditType != "") {
          this.manufactureredit = JSON.parse(res.manufacturerEditType);
          if (this.manufactureredit && this.manufactureredit.length > 0 && res.approvedStatusType == ApproveStatusType.YettobeVerified && this.roleId != RoleType.DBTAdmin) {
            this.manufactureredit.forEach(element => {
              if (element == 1) {
                this.isCorporateContact = false;
              }
              if (element == 2) {
                this.isAuthorizedContact = false;
              }
              if (element == 3) {
                this.isBalanceSheet = false;
              }
              if (element == 4) {
                this.ismsme = false;
              }
            });
          }
        }
        this.form.controls['incorporationTs'].disable();
        // this.form.controls['validityEndTs'].disable();
        // this.form.controls['validityStartTs'].disable();
        this.gstImagePath = res.gstImagePath;
        this.panImagePath = res.panImagePath;


        this.incorporationImagePath = res.incorporationImagePath;
        this.tINImagePath = res.tinImagePath;
        this.miscellaneousImagePath = res.miscellaneousImagePath;

        this.cnImagePath = res.cnImagePath;
        this.msmeImagePath = res.msmeImagePath;
        if (res.companyRegisterType == 1)
          this.msme = true;
        else
          this.msme = false;
        this.msmeFileName = res.cnImagePath;
        this.loadBalanceList = res.balanceSheetViewModel;
        if (this.loadBalanceList != null && this.loadBalanceList.length > 0) {
          this.loadbalance = true;
          if (this.loadBalanceList.length == 1) {
            this.balancesheetform.controls["balanceSheet_file"].setValue(this.loadBalanceList[0].imagePath);
            this.balancesheetform.controls["turnover"].setValue(this.loadBalanceList[0].turnOver);
            this.balanceSheetFileName = this.loadBalanceList[0].imagePath;
          } else if (this.loadBalanceList.length == 2) {
            this.balancesheetform.controls["balanceSheet_file"].setValue(this.loadBalanceList[0].imagePath);
            this.balancesheetform.controls["turnover"].setValue(this.loadBalanceList[0].turnOver);
            this.balancesheetform.controls["balanceSheet_file1"].setValue(this.loadBalanceList[1].imagePath);
            this.balancesheetform.controls["turnover1"].setValue(this.loadBalanceList[1].turnOver);
            this.balanceSheetFileName = this.loadBalanceList[0].imagePath;
            this.balanceSheetFileName1 = this.loadBalanceList[1].imagePath;
          } else {
            this.balancesheetform.controls["balanceSheet_file"].setValue(this.loadBalanceList[0].imagePath);
            this.balancesheetform.controls["turnover"].setValue(this.loadBalanceList[0].turnOver);
            this.balanceSheetFileName = this.loadBalanceList[0].imagePath;
            this.balancesheetform.controls["balanceSheet_file1"].setValue(this.loadBalanceList[1].imagePath);
            this.balancesheetform.controls["turnover1"].setValue(this.loadBalanceList[1].turnOver);
            this.balanceSheetFileName1 = this.loadBalanceList[1].imagePath;
            this.balancesheetform.controls["balanceSheet_file2"].setValue(this.loadBalanceList[2].imagePath);
            this.balancesheetform.controls["turnover2"].setValue(this.loadBalanceList[2].turnOver);
            this.balanceSheetFileName2 = this.loadBalanceList[2].imagePath;
          }

        }
        this.form.patchValue(res);
        if (this.manufacturerDetail?.approvedStatusType == 1) {
          this.form.controls["gstStatus"].setValue("Active")
        }

        if (res.registrationType == 1) {
          this.manufacturer = true;
          this.manufactureranddealer = false;
        } else {
          this.manufacturer = false;
          this.manufactureranddealer = true;
        }
        if (res.gstStatusType == 2) {
          this.gstStatus = true;
        }
        this.form.controls['validityStartTs'].disable();
        this.form.controls['validityEndTs'].disable();
        let state = this.stateListCopy.filter(i => i.key == res.stateId);
        if (state != null && state.length > 0) {
          this.form.controls['stateId'].setValue(state[0].key);
          this.cashBookingService.districtByState(state[0].key, true).subscribe(result => {
            if (result) {
              this.districtList = result;
              this.districtListCopy = result;
              let district = result.filter(i => i.key == res.districtId);
              if (district.length > 0)
                this.form.controls['districtId'].setValue(district[0].key);
              if (district != null && district.length > 0) {
                this.cashBookingService.talukData(district[0].key, 1, true).subscribe(result => {
                  if (result) {
                    this.subDistrictList = result;
                    this.subDistrictListCopy = result;
                    let taluk = result.filter(i => i.key == res.talukId);
                    if (taluk.length > 0)
                      this.form.controls['talukId'].setValue(taluk[0].key);
                    if (taluk != null && taluk.length > 0) {
                      this.cashBookingService.getvillageLookUp(taluk[0].key, 1, true).subscribe(result => {
                        if (result) {
                          this.villageList = result;
                          this.villageListCopy = result;
                          let village = result.filter(i => i.key == res.villageId);
                          if (village.length > 0)
                            this.form.controls['villageId'].setValue(village[0].key);
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }

    });
    this.loading = false;

  }

  download(item: any) {
    // const linkSource = environment.imageBaseUrl + 'DBT/BalanceSheet/' + item;
    // const downloadLink = document.createElement('a');
    // const fileName = 'Leaflet.pdf';
    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
    let src = environment.imageBaseUrl + 'DBT/BalanceSheet/' + item;
    window.open(encodeURI(src), '_blank');
  }

  gstdownload() {
    // const linkSource = environment.imageBaseUrl + 'DBT/GST/' + this.gstImagePath;
    // const downloadLink = document.createElement('a');
    // const fileName = 'TestReportCertificate.pdf';
    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();

    let src = environment.imageBaseUrl + 'DBT/GST/' + this.gstImagePath;
    window.open(encodeURI(src), '_blank');
  }
  incorporationdownload() {
    let src = environment.imageBaseUrl + 'DBT/Incorporation/' + this.incorporationImagePath;
    window.open(encodeURI(src), '_blank');
  }
  tINdownload() {
    let src = environment.imageBaseUrl + 'DBT/TIN/' + this.tINImagePath;
    window.open(encodeURI(src), '_blank');
  }
  miscellaneousdownload() {
    let src = environment.imageBaseUrl + 'DBT/Miscellaneous/' + this.miscellaneousImagePath;
    window.open(encodeURI(src), '_blank');
  }

  cndownload() {
    let src = environment.imageBaseUrl + 'DBT/MSME/' + this.cnImagePath;
    window.open(encodeURI(src), '_blank');
  }


  pandownload() {
    let src = environment.imageBaseUrl + 'DBT/PAN/' + this.panImagePath;
    window.open(encodeURI(src), '_blank');
  }

  msmedownload() {
    let src = environment.imageBaseUrl + 'DBT/MSME/' + this.msmeImagePath;
    window.open(encodeURI(src), '_blank');
  }

  statecommapnyChange() {
    this.getDistricts();
  }

  getDistricts() {
    this.districtList = [];
    this.cashBookingService.districtBySubDivision(1, true).subscribe(result => {
      if (result) {
        this.districtListCopy = result;
      }
    });
  }

  // openFileDialog(item: any) {
  //   let src = environment.imageBaseUrl + 'DBT/BalanceSheet/' + item;
  //   window.open(encodeURI(src ), '_blank')
  // }

  districtChange(event) {
    this.subDistrictList = [];
    this.cashBookingService.talukData(event.value, 1, true).subscribe(result => {
      if (result) {
        this.subDistrictListCopy = result;
      }
    });
  }

  talukChange(event) {
    this.villageList = [];
    this.cashBookingService.getvillageLookUp(event.value, 1, true).subscribe(result => {
      if (result) {
        this.villageListCopy = result;
      }
    });
  }

  stateChange() {
    if (this.form.value.stateId == "Tamil Nadu") {
      this.showtextdistrict = false;
      this.getDistricts();
    } else {
      this.showtextdistrict = true;
    }
  }

  getcompanyRegisteredList(refresh: boolean) {

    this.companyList = [];
    this.companyListCopy = [];
    this.manufacturerService.getCompanyRegisterList(refresh).subscribe(result => {
      if (result) {
        this.companyListCopy = result;
        this.companyList = result;
      }
    });
  }

  goToAction(item: number) {
    var data = {
      id: this.id,
      approvedStatusType: item,
      remarks: "",
    }
    this.manufacturerService.manufacturerApprove(data).subscribe(res => {
      if (res && res.isSuccess) {
        this.alertService.success('Approved Successfully');
        this._location.back();
      } else {
        this.alertService.error(res.htmlFormattedFailures);
      }
    });
  }

  cancel() {
    const title = 'Confirmation';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire(
      {
        title,
        text: 'Are you sure you want to cancel the registration ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          this.router.navigate(['auth/login']);
        }
      });
  }

  showUpdatePopup() {
    const dialogRef = this.addServiceDialog.open(ManufacturerUpdatePopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: '45%',
      height: '55%',
      panelClass: 'mat-dialog-serviceschedule',
      data: {
        id: this.manufacturerDetail?.id,
        mobileNo: this.form.value.mobileNo,
        email: this.form.value.email,
        customerCareNo: this.form.value.customerCareNo,
        customerCareNo1: this.form.value.customerCareNo1,
        customerCareNo2: this.form.value.customerCareNo2,
        corporateContactPersonName: this.form.value.corporateContactPersonName,
        corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
        corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
        corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
        authorizedPersonName: this.form.value.authorizedPersonName,
        authorizedPersonEmail: this.form.value.authorizedPersonEmail,
        authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
        authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
        certificateNumber: this.form.value.certificateNumber,
        manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
        validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
        validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
        attachment: this.attachmentData,
        dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
        approvedStatusType: 0
      }
    });
    dialogRef.afterClosed().subscribe(data => {
      this.onCancel();
      this.isCorporateContact = true;
      this.isAuthorizedContact = true;
      this.isBalanceSheet = true;
      this.ismsme = true;
    });
  }

  submit() {
    this.form.controls['validityEndTs'].clearValidators();
    this.form.controls['validityEndTs'].updateValueAndValidity();

    this.manufacturerTypeIdList = [];
    const selectedManufacturerType = this.form1.get('manufacturerType').value;
    if (selectedManufacturerType && selectedManufacturerType.length > 0) {
      selectedManufacturerType.forEach(element => {
        this.manufacturerTypeIdList.push(element.key);
      });
    }

    this.balanceSheetData = [];
    if (this.loadBalanceList.length == 1 && this.balancesheetform.value.turnover > 0) {
      this.balanceSheetData.push({
        'id': this.loadBalanceList[0].id,
        'year': this.loadBalanceList[0].year,
        'turnOver': JSON.parse(this.balancesheetform.value.turnover),
        'attachment': this.attachmentbalanceSheetData
      });
    }
    else if (this.loadBalanceList.length == 2) {
      if (this.balancesheetform.value.turnover > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[0].id,
          'year': this.loadBalanceList[0].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover),
          'attachment': this.attachmentbalanceSheetData
        });
      }
      if (this.balancesheetform.value.turnover1 > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[1].id,
          'year': this.loadBalanceList[1].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover1),
          'attachment': this.attachmentbalanceSheetData1
        });
      }
    }
    else {
      if (this.balancesheetform.value.turnover > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[0].id,
          'year': this.loadBalanceList[0].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover),
          'attachment': this.attachmentbalanceSheetData
        });
      }
      if (this.balancesheetform.value.turnover1 > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[1].id,
          'year': this.loadBalanceList[1].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover1),
          'attachment': this.attachmentbalanceSheetData1
        });
      }
      if (this.balancesheetform.value.turnover2 > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[2].id,
          'year': this.loadBalanceList[2].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover2),
          'attachment': this.attachmentbalanceSheetData2
        });
      }
    }

    if (this.form.valid) {
      if (this.isSeekClarification) {
        this.showUpdatePopup();
      } else {
        let data = {
          id: this.manufacturerDetail?.id,
          mobileNo: this.form.value.mobileNo,
          email: this.form.value.email,
          customerCareNo: this.form.value.customerCareNo,
          customerCareNo1: this.form.value.customerCareNo1,
          customerCareNo2: this.form.value.customerCareNo2,
          corporateContactPersonName: this.form.value.corporateContactPersonName,
          corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
          corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
          corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
          authorizedPersonName: this.form.value.authorizedPersonName,
          authorizedPersonEmail: this.form.value.authorizedPersonEmail,
          authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
          authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
          certificateNumber: this.form.value.certificateNumber,
          manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
          validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
          validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
          attachment: this.attachmentData,
          dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
        }

        this.manufacturerService.update(data).subscribe(res => {
          if (res && res.isSuccess) {
            this.alertService.success('Manufacturer Updated Successfully');
            this.onCancel();
          }
          else {
            this.alertService.error(res.htmlFormattedFailures);
          }
        });
      }
    } else {
      this.genericValidator.validateFormControl(this.form);
    }
  }

  openPopup() {
    const dialogRef = this.addServiceDialog.open(ManufacturerpopupComponent, {

      autoFocus: false,
      disableClose: true,
      width: '38%',
      height: '45%',
      panelClass: 'mat-dialog-serviceschedule',
      data: {
        id: this.manufacturerDetail?.id,
      }
    });
  }
  oncancel() {
    this._location.back();
  }

  showPopup() {
    const dialogRef = this.addServiceDialog.open(ManufacturerclarifypopupComponent, {

      autoFocus: false,
      disableClose: true,
      width: '45%',
      height: '55%',
      panelClass: 'mat-dialog-serviceschedule',
      data: {
        id: this.id,
      }
    });
  }

  viewproduct(id: number) {
    localStorage.setItem("productdetailId", JSON.stringify(this.id));
    const encId = this.securityService.encrypt(id);
    this.navigationService.goTOProductview(encId, 2);
  }
  back() {
    if (this.roleId == RoleType.DBTAdmin || this.roleId == RoleType.AssistantEngineer || this.roleId == RoleType.AssistantExecutiveEngineer || this.roleId == RoleType.ExecutiveEngineer) {
      this.navigationService.gotomanufacturerlist();
    } else {
      this.navigationService.gotoDealerManufacture()
    }
    // this._location.back();
    // this.navigationService.gotomanufacturerlist();
  }

  approved(event: any, node3) {
    let dbtId=[]
    this.approvedStatusType = event;
    node3.children.forEach(element => {
      if(element.checked && (element.dbtpdmApproveStatusType==0||element.dbtpdmApproveStatusType==2))
      {
        dbtId.push(element.dbtProductDistrictMappingId)
      }
    });
    if (this.approvedStatusType == 0 || this.approvedStatusType === 1) {
      var data = {
        "id": dbtId,
        "approvedStatusType": this.approvedStatusType,
      }
      this.manufacturerService.ApproveProductDealer(data).subscribe(res => {
        // this.TREE_DATA = [];
        // this.dataSource.data = [];
        this.isShow = true;

        this.action(dbtId, 1)
        // this.getmanufacturerTree();
        this.alertService.success("Product Approved Successfully");
      })
    } if (this.approvedStatusType === 3) {
      // const dialogRef = this.addServiceDialog.open(ManufacturerPopupComponent, {
      //   autoFocus: false,
      //   disableClose: true,
      //   width: "45%",
      //   height: "50%",
      //   data: {
      //     id: node3,
      //     approvedStatusType: this.approvedStatusType,
      //   }
      // });
      // dialogRef.afterClosed().subscribe((result) => {
      //   // this.TREE_DATA = [];
      //   // this.dataSource.data = [];
      //   this.isShow = true;
      //   this.action(node3, 3)
      //   // this.getmanufacturerTree();
      // });

      swal.fire({
        title: 'Update Remarks',
        html: 'Rejected Remarks :',
        input: 'textarea',
        inputPlaceholder: 'Type your remarks here...',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#3085d6',
        cancelButtonText: 'Back',
        confirmButtonText: 'Submit',
        allowOutsideClick: false,
        reverseButtons: false,
        inputValidator: (value) => {
          if (!value) {
            return 'Reason is required'
          }
        }
      }).then((result) => {
        let value = result;
        if (value.dismiss) {
          return;
        }
        else {
          if (value.value != '') {
            var data = {
              "id": dbtId,
              "approvedStatusType": this.approvedStatusType,
              "remarks": value.value
            }
            this.manufacturerService.ApproveProductDealer(data).subscribe(res => {
              // this.TREE_DATA = [];
              // this.dataSource.data = [];
              this.isShow = true;
              this.action(dbtId, 3)
              // this.getmanufacturerTree();
              this.alertService.success("Product Rejected Successfully");
            })
          }
        }
      })
    }
  }

  action(prdid, status) {
    this.dataSource.data.forEach(node => {
      if (node.children) {
        node.children.forEach(node1 => {
          if (node1.children) {
            node1.children.forEach(node2 => {
              if (node2.children) {
                node2.children.forEach(node3 => {
                  if (node3){
                    prdid.forEach(element => {
                      if(node3.dbtProductDistrictMappingId ==element)
                      {
                      node3.dbtpdmApproveStatusType = status;

                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  }

 

  unmap(node) {

    this.deleteMenu((`Do You Want to Unmap the Product (${node.name}) ?`), node);
  }

  deleteMenu(message: string, node: any) {
    const title = this.translate.instant('Are you sure ?');
    const Yes = this.translate.instant('Yes');
    const No = this.translate.instant('No');
    swal.fire(
      {
        title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          let id = {
            id: node.dbtProductDistrictMappingId
          }
          this.manufacturerService.delerunmap(id).subscribe(result => {
            if (result && result.isSuccess) {
              this.alertService.success("Product UnMapped Successfully");
              this.TREE_DATA = [];
              this.dataSource.data = [];
              this.isShow = true;
              this.loading = true;
              this.getmanufacturerTree();
            } else if (result && result.isFailure) {
              this.alertService.error(result.htmlFormattedFailures);

            }
          });

        }
      });
  }
}
